var _g, _path, _path2, _circle, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddressSelector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 95,
    viewBox: "0 0 84 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_94_2393)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 33,
    width: 48,
    height: 48,
    rx: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 33.5,
    width: 47,
    height: 47,
    rx: 19.5,
    stroke: "#448199",
    strokeOpacity: 0.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.406 26.2916C59.7283 25.8432 59.6261 25.2183 59.1776 24.896C58.7292 24.5737 58.1043 24.6759 57.782 25.1244L59.406 26.2916ZM36.406 58.2916L37.556 56.6916L35.932 55.5244L34.782 57.1244L36.406 58.2916ZM39.856 53.4916L42.156 50.2916L40.532 49.1244L38.232 52.3244L39.856 53.4916ZM44.456 47.0916L46.756 43.8916L45.132 42.7244L42.832 45.9244L44.456 47.0916ZM49.056 40.6916L51.356 37.4916L49.732 36.3244L47.432 39.5244L49.056 40.6916ZM53.656 34.2916L55.956 31.0916L54.332 29.9244L52.032 33.1244L53.656 34.2916ZM58.256 27.8916L59.406 26.2916L57.782 25.1244L56.632 26.7244L58.256 27.8916ZM60.218 26.8753C60.8627 25.9784 60.6582 24.7286 59.7613 24.084C58.8643 23.4393 57.6146 23.6438 56.97 24.5407L60.218 26.8753ZM37.218 58.8753L38.368 57.2753L35.12 54.9407L33.97 56.5407L37.218 58.8753ZM40.668 54.0753L42.968 50.8753L39.72 48.5407L37.42 51.7407L40.668 54.0753ZM45.268 47.6753L47.568 44.4753L44.32 42.1407L42.02 45.3407L45.268 47.6753ZM49.868 41.2753L52.168 38.0753L48.92 35.7407L46.62 38.9407L49.868 41.2753ZM54.468 34.8753L56.768 31.6753L53.52 29.3407L51.22 32.5407L54.468 34.8753ZM59.068 28.4753L60.218 26.8753L56.97 24.5407L55.82 26.1407L59.068 28.4753Z",
    fill: "#8CD1F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7304 20.2756L65.0943 34.9992C65.114 35.452 65.5437 35.8105 65.9927 35.7488L72.8947 35.3377C73.313 35.3128 73.6502 34.9086 73.5998 34.4926L70.8426 11.7512C70.7921 11.3352 70.3624 10.9767 69.9441 11.0017L47.0768 12.3637C46.6584 12.3886 46.3212 12.7928 46.3717 13.2088L47.2039 20.0728C47.2543 20.4888 47.684 20.8473 48.1023 20.8224L62.832 19.526C63.281 19.4644 63.7107 19.8229 63.7304 20.2756Z",
    fill: "#71C09D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 57,
    r: 5,
    fill: "#8CD1F5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_94_2393",
    x: 0,
    y: 23,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_94_2393"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.266667 0 0 0 0 0.505882 0 0 0 0 0.6 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_94_2393"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_94_2393",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressSelector);
export default __webpack_public_path__ + "static/media/address-selector.fa0b7c269cbc3cafac649b9f0b7ebc33.svg";
export { ForwardRef as ReactComponent };